<template>
  <div id="modalp-template" v-if="visible">
    <div class="modalp-mask">
      <div class="modalp-wrapper">
        <div class="modalp-container">
          <div class="modalp-close-button" @click="$emit('close')">X</div>
          <div class="modalp-body-body">
            <slot name="body">
              <ProductInformation/>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import ProductInformation from "@/components/ProductInformation";

export default {
  name: "ModalPI",
  components: {
    ProductInformation,
  },
  props: {
    visible: {
      type: Boolean,
    },
  },
};
</script>
  
  <style lang="stylus" scoped>
  @import 'ModalPI.styl';
</style>